import {
	Box,
	Button,
	CircularProgress,
	Typography,
	styled
} from '@mui/material';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';

const StyledVideo = styled('video')({
	width: '320px',
	height: '240px'
});

const StyledDropZone = styled(Box)({
	margin: 0,
	height: 140,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	border: '1px dotted #777777',
	backgroundColor: '#fff',
	textAlign: 'center',
	marginBottom: 16,
	cursor: 'pointer'
});

const StyledButton = styled(Button)({
	fontSize: 11,
	textTransform: 'uppercase'
});

const VideoUploader = ({
	circle = false,
	handleUpload,
	label = 'Upload video',
	videoUrl,
	handleDelete,
	...props
}) => {
	const [isEditing, setIsEditing] = useState(false);
	const [_, setFile] = useState();
	const [__, setFiles] = useState([]);
	const [isUploading, setIsUploading] = useState(false);
	const [isUploaded, setIsUploaded] = useState(false);
	const [dropzoneActive, setDropzoneActive] = useState(false);

	const onDrop = async (files) => {
		setIsUploading(true);
		setIsUploaded(false);
		await handleUpload(files[0]);
		setIsEditing(false);
		setIsUploading(false);
		setIsUploaded(true);
		setFiles([]);
		setFile(null);
	};

	const { getRootProps, getInputProps } = useDropzone({
		onDrop,
		accept: {
			'video/*': []
		}
	});

	return (
		<div>
			{videoUrl && !isEditing && <StyledVideo src={videoUrl} controls />}

			{(isEditing || !videoUrl) && (
				<StyledDropZone {...getRootProps()}>
					<input {...getInputProps()} />
					{!isUploaded && !isUploading && !dropzoneActive && (
						<Typography variant="overline">{label}</Typography>
					)}

					{isUploaded && (
						<Typography variant="overline">Upload complete</Typography>
					)}

					{!isUploaded && !isUploading && dropzoneActive && (
						<Typography variant="overline">Drop video</Typography>
					)}

					{!isUploaded && isUploading && <CircularProgress color="primary" />}
				</StyledDropZone>
			)}

			{videoUrl && handleDelete && (
				<Box mb={2} justifyContent="center">
					<StyledButton color="secondary" size="small" onClick={handleDelete}>
						Remove
					</StyledButton>
				</Box>
			)}
		</div>
	);
};

export default VideoUploader;
